/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import jwt_decode from 'jwt-decode'
import root from '../_helpers/roots';

var jwt = require('jwt-simple');


let checkLoginTypeLink = root.checkLoginType.link;
let loginWithOtpLink = root.loginWithOtp.link
let signupLink = root.signUp.link;
let loginLink = root.signupSubscriberLogin.link;
let refreshTokenLink = root.refreshToken.link;

// const authentication = {
export default {
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: {},
    message: '',
    time: '',
    registerConfirmationDetails: {}
    //  setUser: localStorage.getItem('setUser') || ''
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    logout(state) {
      state.status = ''
      state.token = ''
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization']
      // localStorage.removeItem('rf');
      // localStorage.removeItem('cl');
      // localStorage.clear('v');
    },
    updateToken(state, newToken) {
      localStorage.setItem('token', newToken);
      state.token = newToken;
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
    },
    updateRefershToken(state, newToken) {
      localStorage.setItem('rf', newToken);
    },
    removeToken(state) {
      localStorage.removeItem('token');
      localStorage.removeItem('rf');
      state.token = ''
    },
    setTime(state, newTime) {
      localStorage.setItem('cl', newTime)
    },
    registerConfirmationMut(state, value) {
      state.registerConfirmationDetails = value
    }
  },
  actions: {
    checkLoginType(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(checkLoginTypeLink, payload)
          .then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            // localStorage.removeItem('loginType');
            reject(error);
          })
      })
    },
    loginWithOtp(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginWithOtpLink, payload)
          .then(
            (response) => {
              let accessToken = response.data.data.access;
              let refershToken = response.data.data.refresh;
              let loginTime = new Date().getMinutes();
              let timePayload = {
                time: loginTime
              };
              // Encode Time token Payload: time payload and secreate key refresh token
              let loginTimeEncode = jwt.encode(timePayload, refershToken)
              this.commit('updateToken', accessToken);
              // this.commit('updateRefershToken', refershToken);
              // this.commit('setTime', loginTimeEncode)

              resolve(response);
            }
          )
          .catch((error) => {
            localStorage.removeItem('token');
            localStorage.removeItem('rf');
            reject(error);
          })
      })
    },
    login(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginLink, payload)
          .then(
            (response) => {
              localStorage.setItem('LoginedUserID', response.data.data.user.id);
              let accessToken = response.data.data.access;
              let refershToken = response.data.data.refresh;
              let loginTime = new Date().getMinutes();
              let timePayload = {
                time: loginTime
              };
              // Encode Time token Payload: time payload and secreate key refresh token
              let loginTimeEncode = jwt.encode(timePayload, refershToken)
              this.commit('updateToken', accessToken);
              // this.commit('updateRefershToken', refershToken);
              // this.commit('setTime', loginTimeEncode)
              resolve(response);
            }
          )
          .catch((error) => {
            localStorage.removeItem('token');
            localStorage.removeItem('rf');
            reject(error);
          })
      })
    },
    // refreshToken(){
    //     const payload = {
    //         token: localStorage.getItem('rf')
    //     }
    //     axios.post(refreshTokenLink, payload)
    //     .then((response)=>{
    //         this.commit('updateToken', response.data.access);
    //         let loginTime= new Date().getMinutes();
    //         let timePayload = {time: loginTime};

    //         let loginTimeEncode = jwt.encode(timePayload, refershToken)
    //         this.commit('setTime', loginTimeEncode)

    //     })
    //     .catch((error) => {
    //         console.log(error);
    //     })
    // },
    register({
      commit
    }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({
            url: signupLink,
            data: user,
            method: 'POST'
          })
          .then(resp => {
            commit('registerConfirmationMut', resp.data)
            resolve(resp)
          })
          .catch(err => {
            //commit('auth_error', err);
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    logout(context) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('LoginedUserID');
        context.commit('logout')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
    getAuthHeader() {
      return {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    },
    checkAuth() {
      let jwt = localStorage.getItem('token');
      if (jwt != null && jwt != '') {
        this.commit('updateToken', jwt);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwt;
      } else {
        localStorage.removeItem('token');
        this.dispatch('logout');
      }

    },
  },
  getters: {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    registerConfirmationDetailsState: state => state.registerConfirmationDetails
  }
}
//export default authentication;